import React from "react";
import styled from "styled-components";

export const RadioWrapper = styled.div`
    display: flex;
    flex-direction: ${({flexDirection}) =>
            flexDirection ? flexDirection : "row"};
    flex-wrap: wrap;
    gap: 20px;
`;

const Mark = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid ${({bgColor, theme}) => (bgColor ? bgColor : theme.colors.primary)};
    width: 20px;
    height: 20px;
    aspect-ratio: 1/1;
    left: 0;
    border-radius: 100px;
    vertical-align: middle;
    background-color: #fff;

    &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        aspect-ratio: 1/1;
        border-radius: 100px;
        background-color: ${({bgColor, theme}) =>
                bgColor ? bgColor : theme.colors.primary};
        opacity: 0;
        transition: all 110ms;
    }
`;

const Input = styled.input.attrs({
    tabIndex: "0",
})`
    position: absolute;
    opacity: 0;
    -moz-opacity: 0;
    -webkit-opacity: 0;
    -o-opacity: 0;

    &:focus + ${Mark} {
        outline-offset: 5px;
        outline: ${({theme}) => theme.colors.primaryDark} solid 2px;
    }

    &:checked + ${Mark} {
        &::after {
            width: 15px;
            height: 15px;
            opacity: 1;
        }
    }
`;

const Label = styled.label`
    display: flex;
    gap: 6px;
    cursor: pointer;
    padding: 0;
    align-items: center;
    position: relative;
    ${(props) =>
            props.disabled &&
            `   cursor: not-allowed;
        opacity: 0.4;
    `}
`;

export const RadioButton = ({
                                name,
                                id,
                                label,
                                register,
                                color,
                                flexDirection,
                            }) => {
    return (
        <RadioWrapper flexDirection={flexDirection}>
            <Label color={color}>
                <Input
                    color={color}
                    ref={register}
                    type="radio"
                    id={id}
                    key={id}
                    name={name}
                    value={label}
                />
                <Mark htmlFor={id}/>
                {label}
            </Label>
        </RadioWrapper>
    );
};
